/* global squiz */

/**
 *
 * @param target {node} - clicked target (button)
 * @param dataAttr {obj} - {name: attrName, value: attrValue}
 */
const appendVideo = (target, dataAttr) => {

    /**
     *
     * @param {string} videoCode - ex. "cdVUr-NrXng"
     * @param {object} videoSize -  ex. {width: '234', height: '234}
     */
    const appendYoutubeVideo = (videoCode, videoSize) => {
        let aditionalParameters = 'frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"';
        let loopParams = '';
        if([...target.classList].includes('video-card-story--js')) {
            loopParams += `?enablejsapi=1&autoplay=1&loop=1&mute=1&controls=0&origin=${window.location.origin}&playlist=${videoCode}`;
        } else {
            aditionalParameters += ' allowfullscreen';
        }

        const youtubeVideo = `
        <iframe class="lightbox__iframe" width=${videoSize.width} height=${videoSize.height}
            src="https://www.youtube-nocookie.com/embed/${videoCode}${loopParams}"
            ${aditionalParameters}
        >
        </iframe>`;
        target.innerHTML = youtubeVideo;
    };

    const appendVimeoVideo = (videoCode, videoSize) => {
    /**
     *
     * @param {string} videoCode - ex. "134353"
     * @param {object} videoSize -  ex. {width: '234', height: '234}
     */
        let loopParams = '';
        if(target.classList[0] === 'video-card-story--js') {
            loopParams += '?muted=1&autoplay=1&loop=1&controls=0';
        }

        const vimeoVideo = `
        <iframe class="lightbox__iframe" width=${videoSize.width} height=${videoSize.height}
            src="https://player.vimeo.com/video/${videoCode}${loopParams}"
            frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen
        >
        </iframe>`;
        target.innerHTML = vimeoVideo;
    };
    const setVideoSize = () => {
        let height, width;
        if([...target.parentNode.classList].includes('main-banner__background')){
            width = target.offsetWidth;
            height = Math.round(width / 1.7777)
        } else {
            height = Math.round(document.body.clientHeight * 0.8 - 110);
            width = Math.round(height * 1.7777);
        }

        return {width, height};
    }

    //only for lightbox
    if([...target.classList].includes('lightbox__content')) {
        squiz.fn.loadSpiner('hide');
        squiz.fn.lightboxActions('show');
    }

    const videoCode = dataAttr.value,
        isItVimeo = /^[0-9]+$/.test(videoCode),
        videoSize = setVideoSize();

    isItVimeo
        ? appendVimeoVideo(videoCode, videoSize)
        : appendYoutubeVideo(videoCode, videoSize);
}

export default appendVideo
